import React from 'react'
import { GatsbyImage, getImage, StaticImage } from 'gatsby-plugin-image'
import { CallToAction } from 'components/CallToAction'
import { graphql, useStaticQuery } from 'gatsby'
import cntl from 'cntl'
import MarqueeContainer from 'react-fast-marquee'
import { prepareData } from 'utils/googleData'

const sizes = {
    sm: 'border-1 w-16 h-16',
    md: 'border-2 w-20 h-20',
    lg: 'border-2 w-32 h-32',
    xl: 'border-3 w-40 h-40',
}

export const circle = (size = 'lg', className = '') => cntl`
    rounded-full
    relative
    border-gray-accent-light
    border-solid
    inline-block
    bg-white
    ${sizes[size]}
    ${className}
`
export const square = (size = 'lg', className = '') => cntl`
    rounded
    relative
    border-gray-accent-light
    border-solid
    inline-block
    bg-white
    ${sizes[size]}
    ${className}
`
//absolute ${className}
// ${circle(size)}

export const Avatar = ({ size = 'lg', className = '', image, country, name, color }) => {
    return (
        <div className={``}>
            <div style={{ backgroundColor: color ?? 'white' }} className={`${square(size)}`}>
                <GatsbyImage
                    alt={name}
                    image={getImage(image)}
                    className="h-full w-full"
                    imgClassName="w-full h-full border border-solid border-white box-border rounded"
                />
            </div>
        </div>
    )
}

const avatarStyles = [
    { color: '#DCB1E3', className: 'right-[-30.5rem] top-[-2.5rem]', size: 'lg' },
    { color: '#FDEDC9', className: 'right-[-26rem] top-[-12rem]', size: 'lg' },
    { color: '#E19D9D', className: 'right-[-14.5rem] bottom-[-16rem]', size: 'lg' },
    { color: '#A2B0D4', className: 'right-[-14rem] top-[-22.5rem]', size: 'lg' },
    { color: '#9DE1D9', className: 'left-[-30.5rem] top-[-18.5rem]', size: 'lg' },
    { color: '#B3E19D', className: 'left-[-10rem] top-[-19rem]', size: 'lg' },
    { color: '#9DA4E1', className: 'left-[-23rem] bottom-[-14rem]', size: 'lg' },
    { color: '#FBBC05', className: 'left-[-25rem] bottom-[-1.5rem]', size: 'lg' },
    { color: '#E6A9E8', className: 'left-[-6rem] bottom-[-12rem]', size: 'lg' },
    { color: '#E6A9E8', className: 'left-[-6rem] bottom-[-12rem]', size: 'lg' },
]

const AboutTeamMapSubSection = ({ avatarStyles, locationsData, teamMembers, teamMembersToPresent }) => {
    return (
        <div className="relative py-14 text-center md:py-28">
            <div className="inset-1/2 flex scale-[.4] flex-row sm:scale-[.6] md:scale-100">
                <MarqueeContainer autoFill pauseOnHover>
                    {teamMembers?.nodes
                        ?.filter((teamMember) => {
                            const teamMemberToBePresented = teamMembersToPresent.includes(teamMember.frontmatter.name)
                            // console.log(`teamMemberToBePresented ${JSON.stringify(teamMemberToBePresented)}`)
                            return teamMemberToBePresented && teamMembersToPresent.length > 0
                        })
                        .map(({ frontmatter: { name, country, headshot }, parent }, index) => {
                            const styles = avatarStyles[index]
                            const headshotImage = headshot || parent?.cover?.image
                            return (
                                <Avatar
                                    key={name}
                                    size={styles.size}
                                    className={styles.className}
                                    color={styles.color}
                                    image={headshotImage}
                                    name={name}
                                    country={country}
                                />
                            )
                        })}
                </MarqueeContainer>
            </div>
        </div>
    )
}
//
const AboutTeamTitleSubSection = ({ image, title, cta }) => {
    return (
        <>
            <h3 className="mb-4 text-center text-5xl lg:mb-1">{title?.title}</h3>
            <h4 className="text-center font-semibold opacity-70">{title?.subtitle}</h4>
            <div className="mb-4 text-center">
                <CallToAction to={cta.url} type="secondary">
                    {cta.name}
                </CallToAction>
            </div>
        </>
    )
}

export const AboutTeam2 = (props) => {
    const { enable, cta, gatsbyImage, id, style, aboutTeamTitle, teamMembersToPresent, locations } = prepareData({
        props,
    })
    if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
        return <></>
    }
    const { teamMembers } = useStaticQuery(query)
    return (
        <section id={id} className={`px-4 pt-16 pb-12 ${style}`}>
            <AboutTeamTitleSubSection image={gatsbyImage} title={aboutTeamTitle} cta={cta} />
            <AboutTeamMapSubSection
                image={gatsbyImage}
                avatarStyles={avatarStyles}
                teamMembers={teamMembers}
                locationsData={locations}
                teamMembersToPresent={teamMembersToPresent}
            />
        </section>
    )
}

const query = graphql`
    {
        teamMembers: allMdx(
            filter: { fields: { slug: { regex: "/^/team//" } } }
            sort: { fields: frontmatter___startDate }
        ) {
            nodes {
                frontmatter {
                    country
                    name
                    headshot {
                        childImageSharp {
                            gatsbyImageData(placeholder: NONE)
                        }
                    }
                }
                parent {
                    ... on GoogleDocs {
                        cover {
                            image {
                                childImageSharp {
                                    gatsbyImageData
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`
